/**
 * Frontend registry (factory) for Oliver "Interactions".
 *
 * Mirrors c3's: each interaction `type` maps to the Vue component that draws its
 * card and emits a `submit` answer, and to `accepts(card)`, which says whether a
 * saved card has the shape that component draws. A card registers itself in its
 * own `types/<Name>/index.js`; the host and the message pipeline never change.
 */

const registry = {};

export function registerInteraction(type, definition) {
  registry[type] = definition;
}

export function getInteraction(type) {
  return registry[type] || null;
}

/** Whether every question of `card` carries a list under `rows`. */
export function everyQuestionHas(card, rows) {
  const questions = card && card.questions;
  return (
    Array.isArray(questions) &&
    questions.length > 0 &&
    questions.every((q) => q && Array.isArray(q[rows]))
  );
}
